import { useState } from 'react';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';

import { SkillSetDialog } from './skill-sets.dialog';
import { Employee } from '../../../models/masters/employee';
import { GridCountCell } from '../../../components/grid-cell-count';

interface CustomGridCellProps {
  field: string;
}

interface CellProps {
  employee: Employee;
}

const SkillSetCountCell = ({ employee }: CellProps) => {
  const [isDialogVisible, setIsDialogVisible] = useState(false);

  const dialogHandler = () => {
    setIsDialogVisible(!isDialogVisible);
  };

  return (
    <>
      <GridCountCell count={employee.skillSetCount} icon={<DescriptionOutlinedIcon />} onClick={dialogHandler} />
      {isDialogVisible && (
        <SkillSetDialog employeeID={employee.userID} isOpen={isDialogVisible} onCloseClick={dialogHandler} />
      )}
    </>
  );
};

export const CustomGridCell = ({ field }: CustomGridCellProps) => {
  if (field === 'skillSetCount') {
    return (dataItem: any) => {
      return <SkillSetCountCell employee={dataItem.dataItem} />;
    };
  }
};
